import React, { createContext, useEffect, useState } from 'react';
import { Socket } from 'socket.io-client';
import { initSocket } from 'shared/utils/initSocket';

export type SocketContextType = {
  setSocketConnection: (socket: Socket | undefined) => void;
  socket: Socket | undefined;
};

export const SocketContext = createContext<SocketContextType>({
  setSocketConnection: () => {},
  socket: undefined,
});

export const SocketProvider: React.FC = ({ children }) => {
  const [socket, setSocketConnection] = useState<Socket | undefined>(undefined);

  useEffect(() => {
    const token = localStorage.getItem('user');
    const socketConnection = initSocket(token) as Socket; // Ensure `initSocket` returns a `Socket` instance
    setSocketConnection(socketConnection);

    return () => {
      socketConnection?.disconnect(); // Clean up the socket connection on unmount
    };
  }, []);

  return (
    <SocketContext.Provider
      value={{
        setSocketConnection,
        socket,
      }}>
      {children}
    </SocketContext.Provider>
  );
};
